import React, { useState } from 'react';
import { clothingArticles, scoreClothes } from '../util';
import ClothingArticle from './ClothingArticle';
import Egg from './Egg';
import Button from './Button';

function DressUpGame() {
  const [articles, setArticles] = useState(clothingArticles);
  const [score, setScore] = useState(-1);

  const selectArticle = (id) => {
    if (score !== -1) {
      setScore(-1);
    }
    const article = articles.find((article) => article.id === id);
    article.selected = !article.selected;
    setArticles(articles.concat([]));
  };

  const onSubmit = () => {
    setScore(scoreClothes(articles));
  };

  const onClear = () => {
    setScore(-1);
    setArticles(
      articles.map((article) => {
        article.selected = false;
        return article;
      })
    );
  };

  return (
    <div className="dress-up-game">
      <Egg articles={articles} score={score} />
      <div className="score-container">
        <Button className="submit green pixel-corners" onClick={onSubmit}>
          SUBMIT
        </Button>
        <Button className="submit pixel-corners" onClick={onClear}>
          CLEAR
        </Button>
      </div>
      <div className="clothing-container">
        {articles &&
          articles.map((article) => {
            return (
              <ClothingArticle
                id={article.id}
                onClick={selectArticle}
                selected={article.selected}
                key={article.id}
              />
            );
          })}
      </div>
    </div>
  );
}

export default DressUpGame;
